import React, { useState,useEffect } from "react"
import { Modal, Button, Table ,Card,CardBody} from "reactstrap"
import Skeleton from 'react-loading-skeleton'
import { useTranslation } from "react-i18next";

const WizardOverlap = ({LulcHistogramData,showLoading,selectedLanguage}) => {
    const { t, i18n } = useTranslation();

    const [resultObject, setResultObject] = useState({
      [t("Wheat")]: "N/A",
      [t("Mustard")]: "N/A",
      [t("Potato")]: "N/A",
      [t("Pea")]: "N/A",
      [t("Lentil")]: "N/A",
      [t("Gram")]: "N/A",
      [t("Onion")]: "N/A",
      [t("Others")]: "N/A",
    });
    let colors = {
      [t("Paddy")]: "lightColor",
      [t("Maize")]: "fallowColor",
      [t("Jowar")]: "purpleColor",
      [t("Bajra")]: "pinkColor",
      [t("Groundnut")]: "brownColor",
      [t("Soybean")]: "skyColor",
      [t("Others")]: "averageColor",
      [t("Wheat")]: "brownColor",
      [t("Mustard")]: "JowarHarvestedColor",
      [t("Potato")]: "BajraHarvestedColor",
      [t("Pea")]: "GrouHarvestedColor",
      [t("Lentil")]: "soyStandingColor",
      [t("Gram")]: "OtherHarvestedColor",
      [t("Onion")]: "redColor"
    };

    

    useEffect(()=>{

        if(LulcHistogramData )
        {   
           if(JSON.stringify(LulcHistogramData) !== `{}`){

            const mappingObject = {
              "1": t("Paddy"),
              "2": t("Maize"),
              "3": t("Jowar"),
              "4": t("Bajra"),
              "5": t("Groundnut"),
              "6": t("Soybean"),
              "10": t("Others"),
              "11": t("Wheat"),
              "12": t("Mustard"),
              "13": t("Potato"),
              "14": t("Pea"),
              "15": t("Lentil"),
              "16": t("Gram"),
              "17": t("Onion")
            };
           
           
           
             let displayData = {}
             
             Object.keys(LulcHistogramData).map(key => {
                if(mappingObject[Math.floor(parseFloat(key))]!==undefined){
               displayData = { ...displayData, [mappingObject[Math.floor(parseFloat(key))]]: LulcHistogramData[key]}
                }
             })
             setResultObject(displayData)
           }
           else if(JSON.stringify(LulcHistogramData) === `{}`)
           {
           
            setResultObject({
              [t("Paddy")]: "N/A",
              [t("Maize")]: "N/A",
              [t("Jowar")]: "N/A",
              [t("Bajra")]: "N/A",
              [t("Groundnut")]: "N/A",
              [t("Soybean")]: "N/A",
              [t("Others")]: "N/A",
            });
           }
        }
       },[LulcHistogramData,selectedLanguage,t])



  return (
    <Card className=''>
    <CardBody className=' p-3' style={{ backgroundColor: "#F5F5F5" }}>
 {showLoading?<Skeleton count={12}  height="25px"/>
    :<div className='p-2 backgroundColorBeige'>
    {
        Object.keys(resultObject).reverse().map((key) => {
            return (

                <div className='d-flex mt-2' style={{  borderBottom:"1px dashed #f1ecec"}}>
                      {key!=="undefined"?
                        <>
                    <div class={`boxColor ${colors[key]}`}></div>
                    <div className='mx-3'>{key}: &nbsp;<span className='fontBlue'>{resultObject[key]!=="N/A" && resultObject[key]!==0 ?resultObject[key]:"N/A"}</span></div>
                    </>
                    :
                     "" }
                </div>
            )
        })
    }
    </div>
}


      </CardBody>
        </Card>
  )
}

export default WizardOverlap
